// extracted by mini-css-extract-plugin
export default {"border":"ldV50xUFsUbrnqtPLS4Q"};